module.exports = __webpack_public_path__ + "static/00027.25d75983.jpg";